import PaymentComponent from './payments'
export default PaymentComponent
